module.exports = __webpack_public_path__ + "img/shawn.86514900.webp";